import './template_property_landing.css'
